import { createContext } from 'react';

const AppContext = createContext({ state: {}, dispatch: () => {} });

export default AppContext;
